import { types } from 'mobx-state-tree';

import AddressSummary from './AddressSummary';
import orderStatusTranslation from 'js/config/orderStatusTranslation';

export default types
  .model('OrderSummary', {
    alias: types.string,
    buyer: types.string,
    payment_method: types.string,
    price: types.number,
    title: types.string,
    pickup: AddressSummary,
    delivery: AddressSummary,
    status: types.string,
  })
  .views(self => ({
    get human_status() {
      return orderStatusTranslation[self.status];
    },
  }));
